<app-header></app-header>
<div id="schedule-demo-mob" class="mob-schedule-btn">
    <div class="d-flex justify-content-center">
        <a href="https://calendly.com/omnidemo" target="_blank"
            class="bg-button btn btn-primary flex-grow-1 bd-highlight schedule-demo-btn">Schedule a Demo <i
                class="fas fa-angle-right"></i></a>
    </div>

</div>

<div id="top-banner">
    <div class="overlay"></div>
    <div class="animated-text d-flex justify-content-center">
        <marquee class="container" width="100%" direction="left" height="auto">
            Check out OMNI on Microsoft AppSource | OMNI is now launched for Individual users, sign up TODAY! | World’s
            Leading Conversational CX Platform Yellow.ai - now on OMNI | Orchestrate your Enterprise Automation and AI
            on OMNI- powered by Turbotic | OMNI joins hands with Soroco- Discover the power of SCOUT and data mining
        </marquee>
    </div>
    <div class="row col text-center pt-5">
        <div class="toggle-container">
            <a class="toggle-btn">
                <div class="toggle-div active-btn">
                    <span class="toggle-span">For Business</span>
                </div>
            </a>
            <a class="toggle-btn" [routerLink]="['/forindividual']">
                <div class="toggle-div">
                    <span class="toggle-span">For Individuals</span>
                </div>
            </a>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-md-7 header-txt">
                <h1 class="h2">Bridging the gap between Learning and Implementation </h1>
                <h3 class="mt-3">Enterprise platform for AI-RPA upskilling</h3>
                <p class="mb-5" style="font-size:20px;"><span class="orangetxt">O</span>CR - <span
                        class="orangetxt">M</span>achine Learning - <span class="orangetxt">N</span>atural Language
                    Processing - <span class="orangetxt">I</span>ntelligent RPA</p>
                <a [routerLink]="['/schedule-demo']"
                    class="bg-button btn btn-primary flex-grow-1 bd-highlight schedule-demo-btn">Schedule a Demo</a>
            </div>
        </div>
    </div>
</div>



<!--Main Layout-->


<section id="first-feature">
    <div class="container mt-5 mb-5">
        <div class="row justify-content-center">
            <div class="col-md-12 text-center">
                <h2 style="font-size:55px">Experience the power of </h2>

                <div class="rw-wrapper">
                    <h5 class="rw-sentence">
                        <div class="rw-words rw-words-1">
                            <span>AI & RPA to scale automation</span>
                            <span>upskilling by hands-on training</span>
                            <span>independence from external vendors</span>
                            <span>optimized bot license utilization, better ROI</span>
                        </div>
                    </h5>
                </div>

                <p class="text-center f-24 anim-sentence">OMNI is the world's first enterprise hands-on practicing
                    platform for all AI & RPA skills. It helps you to solve the AI and RPA skilling challenge – one
                    citizen developer at a time. </p>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container-fluid mb-5">
        <div class="row align-items-center">

            <div class="col-md-4 offset-md-1 pr-4">
                <h2 class="txt55">What Will You Discover?</h2>
                <h2 class="txt-green">Anyone can Automate!</h2>
                <p class="f-22">Learning automation is easy. Guided by tech professionals, OMNI helps the users to
                    upskill in emerging technologies, such as, Data Science, Artificial intelligence (AI), Machine
                    learning (ML), and Robotic Process Automation (RPA) in a short span of 2 months only! </p>
            </div>

            <div class="col-md-7 pl-3"><video id="firstvideo" loop="" [muted]="'muted'" autoplay="autoplay" preload="auto"
                    width="100%">
                    <source src="https://omni-marketing-assets.s3.amazonaws.com/First.mp4" type="video/mp4" />
                </video></div>
        </div>

    </div>
</section>

<section>
    <div class="container-fluid">
        <div class="row align-items-center mb-5">
            <div class="col-md-7"><video id="secondvideo" loop="" [muted]="'muted'" autoplay="autoplay" preload="auto" width="100%">
                    <!-- <source src="https://omni-marketing-assets.s3.amazonaws.com/Second.mp4" type="video/mp4" /> -->
                    <source src="https://omni-marketing-assets.s3.amazonaws.com/Second.mp4" type="video/mp4" />
                </video></div>
            <div class="col-md-4">
                <h2 class="txt45 mb-3 mt-3">Subscribe to OMNI today to start your <span class="txt-green">AI &
                        Automation journey</span></h2>
                <p class="f-22">By logging into OMNI, working professionals or individual users can complete basic
                    courses and guided assignments with hands-on practice on OMNI’s Sandbox. The sandbox provides access
                    to top AI and RPA platforms such as, UiPath, Automation Anywhere, Power Automate, AutomationEdge,
                    Abbyy, Bot framework, Dialogflow, IBM Watson, etc.</p>
                <p class="f-22 text-justify">OMNI offers you: 1,000+ pre-built downloadable bots. These are ready-to-use
                    solutions and can be directly deployed in your process automation with minimal modification.</p>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container-fluid">
        <div class="row align-items-center mb-5">
            <div class="col-md-7 order-md-12"><img src="assets/img/freedom-vendors.png" class="img-fluid"></div>
            <div class="col-md-4 offset-md-1 order-lg-2">
                <h2 class="txt45 mb-3 mt-3">Freedom from <span class="txt-green">external vendors</span> and Better <span class="txt-green">ROI</span> realization</h2>
                <p class="f-22">OMNI equips the organizations to build their in-house citizen developers with AI &amp; RPA skills
                    who can handle simple workflow automation, reducing the need to depend on external vendors.
                    The in-house team of automation experts can also optimize the utilization of existing licenses,
                    thus increasing the ROI on your overall automation spend.
                </p>
                <p class="f-22">You can evaluate which technology platform and vendor would be right for your
                    organization – before you buy, reducing risk and increasing the probability of success.</p>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row align-items-center mb-5">
            <div class="col-md-7"><video id="end-to-end-journey-video" loop="" [muted]="'muted'" autoplay="autoplay" preload="auto" width="100%">
                    <source src="https://omni-marketing-assets.s3.amazonaws.com/GIF-homepage-website.mp4" type="video/mp4" />
                </video></div>
            <div class="col-md-4">
                <h2 class="txt45 mb-3 mt-3">How OMNI can help you in <span class="txt-green">End-to-End Automation journey</span></h2>
                <p class="f-22">OMNI assists you on every step of your automation journey. Our process mining module provides a
                    deep understanding of the current processes and insights to improve the overall workflow. Through
                    OMNI you can choose the most suitable platforms and tools for your intelligent automation journey.
                    We will guide you at every step of your automation life cycle, be it enabling citizen development,
                    and helping you in automation governance with an assurance of a higher return on your
                    investments.
                </p>
            </div>
        </div>
    </div>
</section>


<section class="pb-2 bg-black">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12 text-center pt-5">
                <h2 class="text-white">Microsoft recognizes the significance of OMNI to democratize automation. </h2>
                <h2 class="txt-green">OMNI is now available on </h2>

                <div class="row justify-content-center pt-5">
                    <div class="col-md-6 mb-3"><a
                            href="https://azuremarketplace.microsoft.com/en-in/marketplace/apps/airodigitallab1590473566928.omni"
                            target="_blank"><img src="assets/img/azure-logo.jpg"></a></div>
                    <div class="col-md-6 mb-3"><a
                            href="https://appsource.microsoft.com/en-us/marketplace/consulting-services/airodigitallab1590473566928.omni_appsource?page=1&search=omni"><img
                                src="assets/img/microsoft-appsource-logo.jpg"></a></div>
                </div>

            </div>
        </div>
    </div>
</section>

<section class="pt-2 pb-2 bg-black">
    <div class="container-fluid">
        <div class="row justify-content-center my-5">
            <div class="col-md-12 text-center mb-3">
                <h4 class="whitetxt">World's top AI and RPA platforms and tools are already available within OMNI.</h4>
            </div>
            <div class="col-md-1 col-6 text-center txt-white mb-3"><img src="assets/img/automation-anywhere.gif"
                    class="img-fluid"><br>Automation<br>Anywhere</div>
            <div class="col-md-1 col-6 text-center txt-white mb-3"><img src="assets/img/ui.gif"
                    class="img-fluid"><br>UiPath</div>
            <div class="col-md-1 col-6 text-center txt-white mb-3"><img src="assets/img/power-automate.gif"
                    class="img-fluid"><br>Power<br>Automate</div>
            <div class="col-md-1 col-6 text-center txt-white mb-3"><img src="assets/img/blue-p.gif"
                    class="img-fluid"><br>Blue<br>Prism</div>
            <div class="col-md-1 col-6 text-center txt-white mb-3"><img src="assets/img/abbyy1.gif"
                    class="img-fluid"><br>ABBYY</div>
            <div class="col-md-1 col-6 text-center txt-white mb-3"><img src="assets/img/dialogflow1.gif"
                    class="img-fluid"><br>Dialogflow</div>
            <div class="col-md-1 col-6 text-center txt-white mb-3"><img src="assets/img/bot1.gif"
                    class="img-fluid"><br>Bot<br>Framework</div>
            <div class="col-md-1 col-6 text-center txt-white mb-3"><img src="assets/img/ibm-watson.gif"
                    class="img-fluid"><br>IBM<br>Watson Assistant</div>
            <div class="col-md-1 col-6 text-center txt-white mb-3"><img src="assets/img/tensor-flow.gif"
                    class="img-fluid"><br>Tensorflow</div>
            <div class="col-6"></div>
        </div>
    </div>
</section>

<section class="container py-5 d-none">
    <div class="row align-items-center justify-content-center my-5">
        <div class="col-md-4 text-center feature-img order-md-1">
            <img src="assets/img/partner.jpg" class="img-fluid">
        </div>

        <div class="col-md-4 ">
            <h2 class="h3">Microsoft partners with OMNI</h2>
            <!--<p class="text-justify">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>-->
        </div>


    </div>
</section>


<section class="container-fluid py-5 bg-orange" style="display: none;">
    <div class="container">
        <div class="row align-items-center justify-content-center">
            <div class="col-md-12 text-center">
                <p class="offer-header-text">Limited Time Offer</p>
                <p class="offer-text">Avail 50% discount on the subscription price till December-31st.</p>
                <a [routerLink]="['/schedule-demo']" target="_blank"
                    class="btn btn-primary flex-grow-1 bd-highlight schedule-demo-btn btn-white">Schedule a Demo</a>
            </div>
        </div>
    </div>
</section>


<section *ngIf="pocList.length > 0" class="container-fluid py-5 bg-grey">
    <div class="container  px-md-0">
        <div class="row justify-content-center">
            <div class="col-md-9 text-center ">
                <h2 class="h2">OMNI Bot Store</h2>
                <p>The largest bot store for top AI-RPA platforms, in one place.</p>
            </div>
        </div>

        <div class="body-content row">
            <div class="col p-0">

                <div class="row course-row">
                    <!--<div class="col-12 p-0"><h2 class="cagory-name h4">Digital 2.0 COE</h2></div>-->
                    <div *ngFor="let poc of pocList" class="col-lg-6 col-xl-4 cursor-pointer" (click)="loadPOC(poc)">
                        <div class="mycourse-card">
                            <div class="course-title d-flex align-items-center mb-3">
                                <span class="overflow-hidden">
                                    <p class="pb-0 m-0 font-small text-uppercase">{{poc.business}}</p>
                                    <p class="h4 m-0">{{poc.technology.toString().replaceAll(",","/")}}</p>
                                    <p class="pb-0 m-0 font-small poc-details">{{poc.title}}</p>
                                </span>
                            </div>
                            <div class="row course-status">
                                <div class="col">
                                    <p *ngFor="let item of poc.platforms" class="image-icon small-icon d-inline-block">
                                        <img title="{{item.platformName}}" src="{{item.platformImage}}" />
                                    </p>
                                    <p class="font-small">Industry: <strong>{{poc.industry}}</strong></p>
                                </div>

                            </div>

                            <!-- <div class="course-bottom border-top d-flex bd-highlight"> 
                          	<div class="flex-grow-1 bd-highlight">                            	
                                <a href="#!" class="border-button btn btn-primary">Details</a>
                            </div>    
                         </div> -->
                        </div>

                    </div>

                </div>




            </div>
        </div>

    </div>
</section>


<app-footer></app-footer>



<div class="modal fade" id="subscribed-modal" tabindex="-1" role="dialog" aria-labelledby="subscribed-modal"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <h5 class="modal-title h3">Thank You for subscribing</h5>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary border-button" data-dismiss="modal">Ok</button>
            </div>
        </div>
    </div>
</div>